import { useEffect } from 'react';

const WhatsAppBubble = ({
  phone = '+27860933333',
  message = 'Virtual Adviser',
  size = 64,
  bottom = 24,
  right = 24,
  side = 'right',
  showLabelDesktop = true,
  labelText = 'Chat on WhatsApp',
  zIndex = 99999,
}) => {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;

    const waURL = (p, t) => {
      const u = 'https://wa.me/' + encodeURIComponent(String(p || '').replace(/\D/g, ''));
      return t ? u + '?text=' + encodeURIComponent(t) : u;
    };

    const css = `.wa-bubble{position:fixed;inset:auto ${side === 'right' ? 'var(--x)' : 'auto'} var(--y) ${
      side === 'left' ? 'var(--x)' : 'auto'
    };width:var(--s);height:var(--s);z-index:${zIndex};display:grid;place-items:center;cursor:pointer;border-radius:999px;
      box-shadow:0 6px 18px rgba(0,0,0,.18);transition:transform .18s ease,box-shadow .18s ease;
      background:linear-gradient(135deg,#25D366,#128C7E)}
      .wa-bubble:active{transform:scale(.98)}
      .wa-bubble:focus{outline:3px solid rgba(37,211,102,.25);outline-offset:3px}
      .wa-bubble::before{content:"";position:absolute;width:calc(var(--s) + 20px);
      height:calc(var(--s) + 20px);border-radius:999px;animation:wa-pulse 2.6s infinite;
      opacity:.65;pointer-events:none;background:radial-gradient(
      circle,rgba(37,211,102,.2) 0%,rgba(37,211,102,.02) 40%,transparent 60%)}
      @keyframes wa-pulse{0%{transform:scale(.9);opacity:.6}70%{transform:scale(1.25);
      opacity:0}100%{transform:scale(1.3);opacity:0}}
      .wa-ico{width:56%;height:56%;display:block;filter:drop-shadow(0 1px 0 rgba(0,0,0,.05))}
      .wa-label{position:fixed;
      inset:auto auto calc(var(--y) + (var(--s)/2) - 14px) calc(var(--x) + var(--s) + 12px);
      background:#fff;color:#0a0a0a;font-weight:600;padding:8px 12px;border-radius:999px;
      box-shadow:0 8px 20px rgba(0,0,0,.12);white-space:nowrap;z-index:${zIndex - 1};
      font-family:system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue",Arial;display:none}
      @media (min-width:900px){.wa-label{display:${showLabelDesktop ? 'block' : 'none'}}}`;

    const style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);

    const btn = document.createElement('button');
    btn.className = 'wa-bubble';
    btn.type = 'button';
    btn.id = 'waBubble';
    btn.setAttribute('aria-label', 'Open WhatsApp chat');
    btn.setAttribute('title', 'Chat on WhatsApp');
    btn.style.setProperty('--s', `${size}px`);
    btn.style.setProperty('--x', `${right}px`);
    btn.style.setProperty('--y', `${bottom}px`);

    btn.innerHTML = `<svg class="wa-ico" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path fill="#fff" d="M20.52 3.48A11.88 11.88 0 0 0 12.03.5C6.31.5 1.72 4.98 1.72 
      10.17c0 1.85.48 3.66 1.39 5.26L.5 23.5l7.36-2.05a11.66 11.66 0 0 0 4.17.75h.01c5.72 
      0 10.32-4.48 10.32-9.69 0-2.66-1.04-5.15-2.83-6.88zM12.03 20.3h-.01a10.06 10.06 0 0 
      1-3.79-.73l-.27-.12-4.36 1.22 1.17-4.02-.17-.3a8.42 8.42 0 0 1-1.35-4.6c0-4.6 
      4.04-8.34 9.01-8.34 2.4 0 4.65.93 6.33 2.62a8.94 8.94 0 0 1 2.62 6.08c0 4.6-4.04 
      8.34-9.01 8.34z"/><path fill="#fff" 
      d="M17.13 14.24c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.78.97-.95 
      1.17-.17.2-.34.22-.64.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.76-1.67-2.06-
      .17-.3-.02-.46.13-.61.13-.13.3-.34.45-.51.15-.17.2-.3.3-.5.1-.2 0-.37-.02-.52-
      .03-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51l-.57-.01c-.2 0-.52.07-.8.37-
      .27.3-1.04 1.02-1.04 2.48 0 1.46 1.07 2.87 1.22 3.07.15.2 2.1 3.3 5.08 4.62 3.02 
      1.33 3.02.89 3.57.83.55-.05 1.78-.72 2.03-1.42.25-.7.25-1.3.18-1.42-.07-.12-.27-
      .2-.57-.35z"/></svg>`;

    const label = document.createElement('div');
    label.className = 'wa-label';
    label.id = 'waLabel';
    label.textContent = labelText;

    const url = waURL(phone, message);

    btn.addEventListener('click', () => {
      window.open(url, '_blank', 'noopener,noreferrer');
    });

    btn.addEventListener('keydown', (ev) => {
      if (ev.key === 'Enter' || ev.key === ' ') {
        ev.preventDefault();
        btn.click();
      }
    });

    document.body.appendChild(btn);
    document.body.appendChild(label);

    return () => {
      try {
        btn.remove();
        label.remove();
        style.remove();
      } catch {
        btn.parentNode && btn.parentNode.removeChild(btn);
        label.parentNode && label.parentNode.removeChild(label);
        style.parentNode && style.parentNode.removeChild(style);
      }
    };
  }, [phone, message, size, bottom, right, side, showLabelDesktop, labelText, zIndex]);

  return null;
};

export default WhatsAppBubble;